<template>
    <div class="select-field form-group admin-m">
        <label>{{field.templateOptions.label}}</label>
        <multiselect v-model="model[field.key]"
                     :options="field.options"
                     :multiple="field.templateOptions.multiple"
                     :disabled="field.templateOptions.isDisabled"
                     label="label"
                     track-by="value"
                     @select="change"
                     :placeholder="$t('selectField.SelectOption')"
                     :deselect-label="$t('button.Delete')"
                     :select-label="$t('selectField.Select')"
                     :selected-label="$t('selectField.Selected')"
                     :close-on-select="field.templateOptions.closeOnSelect">
        </multiselect>

        <error-display :form="form" :field="field.key"></error-display>
    </div>
</template>

<script>
  import baseField from 'vue-formly-bootstrap/src/fields/baseField';

  export default {
    name: 'MultiSelectField',
    mixins: [baseField],
    components: {
      Multiselect: () => import('vue-multiselect')
    },
    methods: {
      change(selectedOption) {
        this.onChange(selectedOption);
        this.$set(this.model, this.field.key, selectedOption);
      }
    }
  };
</script>

<style scoped>
    @import "~vue-multiselect/dist/vue-multiselect.min.css";
</style>
